import axios from "axios";
const { REACT_APP_EXTRANET_URL } = process.env;

async function getPaginatedNotifications(query?: string) {
  let params = query ? query : "pag=1&res=20";
  try {
    const res = await axios.get(
      `${REACT_APP_EXTRANET_URL}/my-notifications/?${params}`
    );
    return res.data.notifications;
  } catch (err) {}
}

async function getNotification(mynotificationId: number) {
  const res = await axios.get(
    `${REACT_APP_EXTRANET_URL}/my-notifications/id/${mynotificationId}`
  );
  return res.data;
}

export const MyNotificationsApi = {
  getPaginatedNotifications,
  getNotification,
};
